function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L20 0L20 20L0 20L0 0Z",
  id: "social_path_1"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "social_mask_1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#social_path_1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "user-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L20 0L20 20L0 20L0 0Z",
  id: "user-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#social_mask_1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(6.9560547 3.4785156)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 3.04349C0 4.72178 1.3652 6.08698 3.04348 6.08698C4.72176 6.08698 6.08696 4.72174 6.08696 3.04349C6.08696 1.36524 4.72176 0 3.04348 0C1.36524 0 0 1.3652 0 3.04349ZM0.86959 3.04349C0.86959 1.84524 1.84524 0.869592 3.04348 0.869592C4.24173 0.869592 5.21737 1.84524 5.21737 3.04349C5.21737 4.24174 4.24177 5.21739 3.04348 5.21739C1.84524 5.21739 0.86959 4.24174 0.86959 3.04349Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(13.913086 6.9570312)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 2.17391C0 3.37216 0.975651 4.34781 2.1739 4.34781C3.37214 4.34781 4.3478 3.37216 4.3478 2.17391C4.3478 0.975655 3.37214 0 2.1739 0C0.975651 0 0 0.975655 0 2.17391ZM0.86955 2.17391C0.86955 1.45476 1.45475 0.869554 2.1739 0.869554C2.89304 0.869554 3.47825 1.45476 3.47825 2.17391C3.47825 2.89305 2.893 3.47826 2.1739 3.47826C1.45475 3.47826 0.86955 2.89305 0.86955 2.17391Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(1.8007812 6.9570312)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 2.17391C0 3.37216 0.97565 4.34781 2.17389 4.34781C3.37214 4.34781 4.34779 3.37216 4.34779 2.17391C4.34779 0.975655 3.37299 0 2.17389 0C0.974753 0 0 0.975655 0 2.17391ZM0.86955 2.17391C0.86955 1.45476 1.45475 0.869554 2.17389 0.869554C2.89304 0.869554 3.47824 1.45476 3.47824 2.17391C3.47824 2.89305 2.893 3.47826 2.17389 3.47826C1.45475 3.47826 0.86955 2.89305 0.86955 2.17391Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(4.3476562 10.43457)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 5.65217C0 5.89217 0.194796 6.08696 0.434796 6.08696C0.674796 6.08696 0.869592 5.89217 0.869592 5.65217C0.869592 3.01479 3.01479 0.86959 5.65218 0.86959C8.28957 0.86959 10.4348 3.01479 10.4348 5.65217C10.4348 5.89217 10.6296 6.08696 10.8696 6.08696C11.1096 6.08696 11.3044 5.89217 11.3044 5.65217C11.3044 2.53564 8.76872 0 5.65218 0C2.53565 0 0 2.53564 0 5.65217Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(13.850586 12.173828)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.208936 0.565231C0.00460119 0.690448 -0.0615126 0.957391 0.0628494 1.16262C0.188923 1.36785 0.45501 1.43307 0.660242 1.30871C1.13413 1.02085 1.67849 0.869551 2.2359 0.869551C3.91416 0.869551 5.27941 2.23475 5.27941 3.91304C5.27941 4.15304 5.4742 4.34784 5.7142 4.34784C5.95421 4.34784 6.149 4.15304 6.149 3.91304C6.14896 1.75565 4.3933 0 2.2359 0C1.52026 0 0.819374 0.195652 0.208936 0.565231Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0 12.173828)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.91304 0C1.75565 0 0 1.75565 0 3.91304C0 4.15304 0.194796 4.34784 0.434796 4.34784C0.674796 4.34784 0.869592 4.15304 0.869592 3.91304C0.869551 2.23475 2.23479 0.869551 3.91304 0.869551C4.47045 0.869551 5.01477 1.02086 5.48784 1.30781C5.69217 1.43217 5.96001 1.36696 6.08523 1.16172C6.21044 0.956494 6.14433 0.689551 5.93914 0.564334C5.32956 0.195652 4.62872 0 3.91304 0Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
})))));

var SvgSocial = function SvgSocial(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSocial, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/social.9dd9669a.svg";
export { ForwardRef as ReactComponent };